import React from 'react';

// Line icons for product facts, drawn on one 24px grid so a row of them reads
// as a set. Content names an icon (`icon: 'wind'`); an unknown name falls
// back to a tick rather than rendering nothing.
const PATHS = {
  wind: <path d="M4 8h10a3 3 0 1 0-3-3M4 14h14a3 3 0 1 1-3 3M4 11h6" strokeLinecap="round" strokeLinejoin="round" />,
  fabric: <path d="M4 5h16v14H4zM4 9h16M4 13h16M4 17h16" strokeLinejoin="round" />,
  led: <path d="M9 18h6M10 21h4M12 3a6 6 0 0 1 4 10.5V16H8v-2.5A6 6 0 0 1 12 3Z" strokeLinecap="round" strokeLinejoin="round" />,
  motor: <><rect x="3" y="8" width="18" height="9" rx="2" /><path d="M7 8V6h10v2M12 12v2" strokeLinecap="round" /></>,
  stock: <path d="M20 7 9 18l-5-5" strokeLinecap="round" strokeLinejoin="round" />,
  uv: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" strokeLinecap="round" /></>,
  cert: <><path d="M12 3l7 3v5.5c0 4.2-2.9 7.6-7 8.5-4.1-.9-7-4.3-7-8.5V6l7-3Z" strokeLinejoin="round" /><path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" /></>,
  size: <><path d="M3 17 17 3l4 4L7 21l-4-4Z" strokeLinejoin="round" /><path d="m7 13 2 2M10 10l2 2M13 7l2 2" strokeLinecap="round" /></>,
  plug: <><path d="M9 3v5M15 3v5M6 8h12v3a6 6 0 0 1-12 0V8ZM12 17v4" strokeLinecap="round" strokeLinejoin="round" /></>,
};

export default function ProductIcon({ name }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      {PATHS[name] || PATHS.stock}
    </svg>
  );
}
